const cianApiPattern = /^\/(public\/)?v\d+\//;
const numberPattern = /\d+/g;
const slashPattern = /\/{2,}/g;
export function cleanPath(pathname) {
    const cianApi = pathname.match(cianApiPattern);
    let prefix = '';
    let api = pathname;
    if (cianApi) {
        prefix = cianApi[0];
        api = pathname.slice(prefix.length);
    }
    // Возможно цифры нужно заменять на символ N
    return prefix + api.replace(numberPattern, '').replace(slashPattern, '/');
}
//# sourceMappingURL=pathSimplified.js.map